export default __webpack_public_path__ + "static/media/checked-in-green.8c57a208.svg";